<template>
  <div class="user_navi">
    <div :class="`user_navi_one ` + ($route.meta.title==='修改密码' ? 'user_navi_selected' : '')" @click="toPassword">
      修改密码
    </div>
  </div>
</template>

<script>
  import { getJsonStorage } from "../../util/storage";

  export default {
    name: "UserNavi",
    data() {
      return {

      }
    },
    mounted(){

    },
    methods: {
      toMissions(){
        if(this.$route.meta.title!=='关注船舶'){
          this.$router.push('/user/missions');
        }
      },
      toCoupons(){
        if(this.$route.meta.title!=='已购项目'){
          this.$router.push('/user/coupons');
        }
      },
      toUsed(){
        if(this.$route.meta.title!=='服务记录'){
          this.$router.push('/user/used');
        }
      },
      toPassword(){
        if(this.$route.meta.title!=='修改密码'){
          this.$router.push('/user/password');
        }
      },
      toUserDetail(){
        this.$router.push('/user/detail');
      }
    }
  }
</script>

<style scoped>
  .user_navi {
    width: 100%;
    height:5vh;
    line-height:5vh;
    top:6vh;
    font-size:.8rem;
    color:#666;
  }
  .user_navi_one {
    width:21%;
    margin:0 2%;
    float:left;
    height:5vh;
    line-height:5vh;
    text-align:center;
  }
  .user_navi_selected {
    line-height:4vh;
    font-weight:bold;
    font-size:1rem;
    color:#333;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/navi.vue